const getRegexPattern = (keywordArray: string[]) => {
  const pattern = '(\\b|)(' + keywordArray.join('|') + ')(|\\b)';
  return new RegExp(pattern, 'gi');
};

const splitMulti = (str: string, separators: string[]) => {
  const tempChar = 't3mp';
  const regExForExactMatch = /"([^"]+)"|'([^']+)'/g;
  let exactMatchList: string[] = [];
  if (str.match(regExForExactMatch)) {
    exactMatchList =
      str && str.match(regExForExactMatch)
        ? str.match(regExForExactMatch)?.map(function (s) {
            return s.substring(1, s.length - 1);
          }) ?? []
        : [];
  }
  const re = new RegExp('/' + separators.join('|') + '/', 'gi');
  const chars = str.replace(regExForExactMatch, '').replace(re, tempChar).split(tempChar);
  const splitKeywords: string[] = [];
  // exactMatchList.map((keyWord) =>
  //   keyWord
  //     ?.split(' ')
  //     ?.filter((el) => el.length > 0)
  //     .map((el) => splitKeywords.push(el?.trim()))
  // );
  return exactMatchList
    .concat(splitKeywords)
    .concat(chars.map((el: string) => el.trim()).filter((el) => el.length > 0));
};

export const highlightKeys = (textToHighlight: string, keywords: string) => {
  let filteredText = textToHighlight;
  if (keywords) {
    const pattern = getSearchRegExp(keywords);
    filteredText = textToHighlight.replace(pattern ?? new RegExp(''), '<em>$2</em>');
  }
  return filteredText;
};

export const getSearchRegExp = (keywords: string | null) => {
  if (keywords) {
    keywords = keywords.replace(/[()+*]/g, ' ');
    const keywordList = splitMulti(keywords, [' and ', ' or ', ' AND ', ' OR ', '\\(', '\\)']);
    return getRegexPattern(keywordList);
  }
  return undefined;
};
